// extracted by mini-css-extract-plugin
module.exports = {"particleCanvas":"Particle_particleCanvas_1-2P5"};